<template>
  <review
    :edit-reviews="reviews"
    :related-id="okrListId"
    :can-edit="canEdit"
    @review-saved="getOverallReviews"
  />
</template>
<script>
import Review from './review.vue'
import { getOverallReviews as getOverallReviewsApi } from '@/api/okr'
import { ref } from 'vue'
export default {
  components: {
    Review
  },
  props: {
    okrListId: {
      type: Number,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: true
    }
  },
  setup (props) {
    const reviews = ref([])
    getOverallReviews()

    // 查询okr总体复盘
    function getOverallReviews () {
      getOverallReviewsApi(props.okrListId).then(res => {
        reviews.value = res.overallReviews
      })
    }

    return {
      reviews,
      getOverallReviews
    }
  }
}
</script>
